import React from 'react';
import { Truck } from 'lucide-react';

const productLinks = ['Features', 'Pricing', 'Integrations', 'Changelog', 'Roadmap'];
const companyLinks = ['About', 'Blog', 'Careers', 'Contact', 'Press'];
const legalLinks = ['Privacy Policy', 'Terms of Service', 'Cookie Policy', 'Security'];

const FooterColumn = ({ header, links }) => (
  <div>
    <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">
      {header}
    </h4>
    <ul className="space-y-3">
      {links.map((link) => (
        <li key={link}>
          <a
            href="/"
            className="text-sm text-gray-500 hover:text-gray-300 transition-colors"
          >
            {link}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

const Footer = () => {
  return (
    <footer className="bg-[#020617] py-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <Truck className="text-blue-500" size={22} />
              <span className="text-white font-bold text-lg">LoadApp</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Fleet management, simplified.
            </p>
          </div>

          <FooterColumn header="Product" links={productLinks} />
          <FooterColumn header="Company" links={companyLinks} />
          <FooterColumn header="Legal" links={legalLinks} />
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-gray-600">
          <span>© 2026 LoadApp. All rights reserved.</span>
          <span>Built with Supabase</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
